var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 7.29991C20.6 5.99991 21.5 4.69993 22.6 3.69993C25.2 1.19993 28.2 0.499942 31.4 1.89994C34.6 3.19994 36.6 5.99991 37.1 9.79991C37.6 13.0999 36.8 16.0999 34.7 18.3999C29.7 24.0999 24.7001 29.7999 19.8001 35.4999C19.6001 35.6999 19.5001 35.6999 19.3001 35.4999C14.4001 29.7999 9.40002 24.1999 4.50002 18.4999C2.00002 15.5999 1.30005 12.0999 2.40005 8.19993C3.50005 4.29993 5.90005 1.99991 9.40005 1.29991C12.2 0.799906 14.8 1.69994 16.9 3.89994C17.7 4.99994 18.5 6.09991 19.6 7.29991Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.53790a2ccdee38baf45b791b9e3d0258.svg";
export { ForwardRef as ReactComponent };